<template>
    <vx-expandable-card>
        <template v-slot:content>
            <div v-if="props.phoneNumber.is_hosted">
                <vx-label size="md">Inbound Call Strategy</vx-label>
                <div class="text-sm text-slate-700">This number is hosted, so voice stays with its carrier and is not configurable.</div>
            </div>
            <div v-else class="flex flex-col gap-4">
                <div>
                    <vx-label size="md">Inbound Call Strategy</vx-label>
                    <div class="text-sm text-slate-700" data-test="strategy">{{ strategy ? strategyLabels[strategy] : '-' }}</div>
                </div>

                <div v-if="strategy === 'say'">
                    <vx-label size="md">Message</vx-label>
                    <div class="text-sm text-slate-700 whitespace-pre-line" data-test="voice_message_text">{{ props.phoneNumber.voice_message_text }}</div>
                </div>

                <template v-if="strategy === 'forward'">
                    <div>
                        <vx-label size="md">Forward to</vx-label>
                        <div class="text-sm text-slate-700" data-test="forward_voice_to">{{ formatPhoneNumber(props.phoneNumber.forward_voice_to ?? '') }}</div>
                    </div>

                    <div v-if="props.phoneNumber.forward_voice_send_digits">
                        <vx-label size="md">Press digits after forward</vx-label>
                        <div class="text-sm text-slate-700" data-test="forward_voice_send_digits">{{ props.phoneNumber.forward_voice_send_digits }}</div>
                    </div>
                </template>
            </div>
        </template>
    </vx-expandable-card>
</template>

<script setup lang="ts">
import { VxExpandableCard, VxLabel } from '@voxie/frontend-components';
import { computed } from 'vue';
import { formatPhoneNumber } from '~/components/filters';
import type { PhoneNumber } from '~/services/phoneNumbersClient.types';

type Strategy = 'default' | 'forward' | 'say';

const strategyLabels: Record<Strategy, string> = {
    default: "Tell callers calls aren't supported",
    forward: 'Forward call to another number',
    say: 'Say the given message',
};

const props = defineProps<{
    phoneNumber: Partial<PhoneNumber>;
}>();

const strategy = computed<Strategy | undefined>(() => {
    if (props.phoneNumber.forward_voice_to) {
        return 'forward';
    }

    if (props.phoneNumber.voice_message_text) {
        return 'say';
    }

    if (props.phoneNumber.id) {
        return 'default';
    }

    return undefined;
});
</script>
